module.exports = __webpack_public_path__ + "media/4-e.3c9b8b18.wav";